/**
 * @fileoverview PATCH handler for the "/apps/user_info/update_merge_duplicate_users_rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoUpdateMergeDuplicateUsersRulesCacheKeys } from "./constants";
import type {
  PatchUpdateMergeDuplicateUsersRulesProps,
  AppsUserInfoUpdateMergeDuplicateUsersRulesResult,
} from "./types";

export const patchAppsUserInfoUpdateMergeDuplicateUsersRules = reactQueryMutationAdapter(
  appsUserInfoUpdateMergeDuplicateUsersRulesCacheKeys,
  (props: PatchUpdateMergeDuplicateUsersRulesProps): Promise<AppsUserInfoUpdateMergeDuplicateUsersRulesResult> => {
    return fetch("/apps/user_info/update_merge_duplicate_users_rules", "PATCH", {
      identifier: props.identifier,
      sort_order: props.sort_order,
      tiebreaker_field: props.tiebreaker_field,
    });
  }
);
